module.exports = __webpack_public_path__ + "static/media/wrench.0e37d194.svg";